import React from 'react';
import UzmanSeti from './UzmanSeti';

// LGS SETİ — 8. sınıf LGS soruları (4 şık, A–D). Yalnız super_admin görür
// (backend: GET /api/sorular/lgs-set rolKontrol + izole sorular_lgs tablosu).
// Panel UzmanSeti'nin aynısı (kazanım kapsamı, basım adedi, numara listesi, Basım'a gönder);
// yalnız ayar farklı. Hedefler pilot belirtkesinden: LGS_soruYaz/referans/lgs_mat_pilot/belirtke.json.
export const HEDEF = {
  'MAT.8.1.2': { ad: 'Kareköklü ifadeler', adet: 3 },
  'MAT.8.2.2': { ad: 'Doğrusal ilişkiler ve fonksiyonlar', adet: 1 },
  'MAT.8.3.6': { ad: 'Üçgen: açı-kenar, eşitsizlik, Pisagor', adet: 2 },
  'MAT.8.6.1': { ad: 'Veriye dayalı karar', adet: 2 },
  'MAT.8.7.1': { ad: 'Olasılık yaklaşımları', adet: 2 },
};

export const LGS_AYAR = {
  endpoint: '/api/sorular/lgs-set',
  hedef: HEDEF,
  geriGizli: true,   // lgs.* üst bandındaki sekmeler gezinmeyi taşır
  harfler: ['A', 'B', 'C', 'D'],
  baslik: 'LGS Seti',
  altBaslik: 'Matematik pilotu, 4 şıklı sorular',
  figurEtiket: 'Figürlü (hedef ~%90)',
  bosMetin: 'Henüz LGS sorusu yok. Üretim: /soru-uret-lgs-matematik',
  // "Optik form" belirteçleri (tailwind lgs.*): seçili satır açık optik, düğme optik, çubuklar kurşun kalem.
  renk: { satir: 'bg-lgs-optikacik', dugme: 'bg-lgs-optik', cubuk: 'bg-lgs-murekkep' },
};

export default function LgsSeti(props) {
  return <UzmanSeti {...props} ayar={LGS_AYAR} />;
}
